import "../../../stylesheets/components/forms/messages.scss";

function SucessMessage(props) {
    return (
        <p className="mt-3 success-msg">{props.children}</p>
    )
}

export default SucessMessage
